import { render, staticRenderFns } from "./ViewSupplies.vue?vue&type=template&id=0ff7033f&scoped=true"
import script from "./ViewSupplies.vue?vue&type=script&lang=js"
export * from "./ViewSupplies.vue?vue&type=script&lang=js"
import style0 from "./ViewSupplies.vue?vue&type=style&index=0&id=0ff7033f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff7033f",
  null
  
)

export default component.exports